export const SHORT_VERSION_LENGTH = 5
export const ALL_TRIGGERS_KEY = 'all_triggers'
